import React from 'react'
import { DcButton, DcFlexBox, DcInput } from 'pixel-base'

interface ProductSearchProps {
  searchValue: string
  setSearchValue: (value: string) => void
  debounceFn: (value: string) => void
  setShowSearchProduct: (show: boolean) => void
}

export const ProductSearch: React.FC<ProductSearchProps> = ({
  searchValue,
  setSearchValue,
  debounceFn,
  setShowSearchProduct,
}) => {
  return (
    <DcFlexBox
      height="auto"
      gap="10px"
      style={{
        background: '#f8f9fa',
        padding: '15px',
        borderRadius: '8px',
        marginBottom: '15px',
        border: '1px solid #e9ecef',
      }}
    >
      <DcFlexBox style={{ flex: 1, gap: '10px' }}>
        <DcInput
          name="search"
          showsearchicon={1}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value)
            debounceFn(e.target.value)
          }}
          placeholder={'Search Product by SKU or Name'}
          style={{ flex: 1 }}
        />
        <DcButton
          variant="outline-primary"
          onClick={() => {
            setShowSearchProduct(true)
          }}
        >
          Browse
        </DcButton>
      </DcFlexBox>
    </DcFlexBox>
  )
}
